module.exports = __webpack_public_path__ + "img/square-dollar.d594c57a.svg";